import React from 'react';
import SendMessageSection from '../components/send-message/SendMessageSection';

function SendMessage() {
  return (
    <SendMessageSection isHomePage={false} />
  );
}

export default SendMessage;
